// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trades-container {
  padding: 0.5rem;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}

.trades-header {
  margin-bottom: 1rem;
}

.trades-header h2 {
  margin: 0;
  color: #333;
  font-size: 2rem;
}

.trades-header p {
  margin: 0.5rem 0 0 0;
  color: #666;
}

.trades-content {
  width: 100%;
  box-sizing: border-box;
}

.trades-controls {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.broker-selector,
.account-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.broker-selector label,
.account-selector label {
  font-weight: 500;
  color: #333;
}

.broker-selector select,
.account-selector select {
  padding: 8px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.broker-selector select:focus,
.account-selector select:focus {
  outline: none;
  border-color: #667eea;
}

.trade-filter-selector,
.date-range-selector,
.symbol-filter-selector,
.tag-filter-selector,
.position-filter-selector,
.option-type-filter-selector,
.group-by-conid-selector,
.pnl-period-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.trade-filter-selector label,
.date-range-selector label,
.symbol-filter-selector label,
.tag-filter-selector label,
.position-filter-selector label,
.option-type-filter-selector label,
.group-by-conid-selector label,
.pnl-period-selector label {
  font-weight: 500;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-by-conid-selector input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.column-visibility-selector {
  position: relative;
  margin-left: auto;
  align-self: center;
}

.column-visibility-selector summary {
  list-style: none;
  padding: 8px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  background: white;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.column-visibility-selector summary::-webkit-details-marker {
  display: none;
}

.column-visibility-selector summary::after {
  content: ' \\25BE';
}

.column-visibility-selector[open] summary {
  border-color: #667eea;
}

.column-visibility-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 10;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  padding: 8px 0;
  min-width: 180px;
  max-height: 320px;
  overflow-y: auto;
}

.column-visibility-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
}

.column-visibility-option:hover {
  background: #f8f9fa;
}

.column-visibility-option input[type="checkbox"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.trade-filter-selector select,
.date-range-selector select,
.symbol-filter-selector input,
.tag-filter-selector input,
.position-filter-selector select,
.option-type-filter-selector select,
.pnl-period-selector select {
  padding: 8px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s ease;
  min-width: 150px;
}

.trade-filter-selector select:focus,
.date-range-selector select:focus,
.symbol-filter-selector input:focus,
.tag-filter-selector input:focus,
.position-filter-selector select:focus,
.option-type-filter-selector select:focus,
.pnl-period-selector select:focus {
  outline: none;
  border-color: #667eea;
}

.symbol-filter-selector input {
  cursor: text;
}

.trades-table-container {
  overflow-x: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.trades-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
  table-layout: auto;
}

.trades-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.trades-table th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
}

.sortable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.sortable-header:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.trades-table tbody tr {
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;
}

.trades-table tbody tr:hover {
  background-color: #f9f9f9;
}

.trades-table tbody tr:last-child {
  border-bottom: none;
}

.trades-table td {
  padding: 10px 8px;
  font-size: 0.85rem;
  text-align: left;
}

.account-cell {
  font-weight: 500;
  color: #667eea;
}

.date-cell {
  font-weight: 500;
  color: #333;
  font-family: 'Courier New', monospace;
}

.symbol-cell {
  font-weight: 600;
  color: #333;
}

.description-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #555;
}

.buy-sell-cell {
  font-weight: 600;
  text-transform: uppercase;
  color: #333;
}

.number-cell {
  text-align: left;
  font-family: 'Courier New', monospace;
  color: #555;
}

.number-cell.positive {
  color: #2e7d32;
  font-weight: 600;
}

.number-cell.negative {
  color: #d32f2f;
  font-weight: 600;
}

.number-cell.unrealized {
  color: #ff8c00;
  font-weight: 600;
}

.currency-cell {
  text-align: left;
  color: #666;
  font-size: 0.85rem;
}

.loading, .error, .empty-state {
  text-align: center;
  padding: 3rem 2rem;
  font-size: 1.1rem;
}

.error {
  color: #d32f2f;
  background-color: #ffebee;
  border-radius: 4px;
  border: 1px solid #ffcdd2;
}

.empty-state {
  color: #666;
  background: white;
  border-radius: 8px;
  padding: 4rem 2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

@media (max-width: 1400px) {
  .trades-container {
    padding: 0.25rem;
  }
  
  .trades-table th,
  .trades-table td {
    padding: 8px 6px;
    font-size: 0.85rem;
  }
  
  .description-cell {
    max-width: 180px;
  }
}

@media (max-width: 1200px) {
  .trades-container {
    padding: 0.25rem;
  }
  
  .trades-table th,
  .trades-table td {
    padding: 8px 5px;
    font-size: 0.8rem;
  }
  
  .description-cell {
    max-width: 150px;
  }
}

@media (max-width: 768px) {
  .trades-container {
    padding: 0.25rem;
  }
  
  .trades-table-container {
    font-size: 0.75rem;
  }

  .trades-table th,
  .trades-table td {
    padding: 6px 4px;
    font-size: 0.75rem;
  }
  
  .description-cell {
    max-width: 100px;
  }
}

/* Grouped trades view styles */
.group-header-row {
  background-color: #f5f5f5 !important;
  font-weight: 600;
  border-top: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
}

.group-header-row:hover {
  background-color: #e8e8e8 !important;
}

.group-header-row .symbol-cell {
  font-size: 1rem;
  color: #667eea;
}

.group-detail-header-row {
  background-color: #f0f0f0 !important;
  font-weight: 600;
  font-size: 0.85rem;
  border-bottom: 1px solid #ddd;
}

.group-detail-header-cell {
  padding: 8px 8px !important;
  color: #555;
  font-size: 0.85rem;
}

.group-detail-row {
  background-color: #fafafa !important;
}

.group-detail-row:hover {
  background-color: #f0f0f0 !important;
}

.group-detail-row td {
  padding-left: 2rem;
  font-size: 0.85rem;
}

/* Totals row styling */
.totals-row {
  background-color: #f5f5f5 !important;
  border-top: 3px solid #667eea;
  font-weight: 700;
}

.totals-row:hover {
  background-color: #f5f5f5 !important;
}

.totals-cell {
  padding: 12px 8px !important;
  font-size: 0.95rem;
  text-align: left;
}

.totals-cell.number-cell {
  text-align: left;
  font-family: 'Courier New', monospace;
  font-size: 1rem;
}

/* Info Section Styles */
.info-section {
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
}

.info-content {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  max-width: 1200px;
  margin: 0 auto;
}

.info-content h3 {
  color: #333;
  font-size: 1.8rem;
  margin: 0 0 2rem 0;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e0e0e0;
}

.info-content h4 {
  color: #444;
  font-size: 1.4rem;
  margin: 2rem 0 1rem 0;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
}

.info-content h4:first-of-type {
  border-top: none;
  margin-top: 0;
  padding-top: 0;
}

.info-content h5 {
  color: #555;
  font-size: 1.2rem;
  margin: 1.5rem 0 0.75rem 0;
}

.info-intro {
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0.5rem 0 1rem 0;
}

.info-section-block {
  margin-bottom: 2rem;
}

.info-subsection {
  margin: 1.5rem 0;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 6px;
  border-left: 4px solid #2196F3;
}

.info-note {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 0.75rem 1rem;
  margin: 1rem 0;
  color: #856404;
  font-size: 0.95rem;
  line-height: 1.5;
}

.info-rules-list {
  list-style: none;
  padding: 0;
  margin: 1rem 0;
}

.info-rules-list li {
  padding: 0.75rem 1rem;
  margin: 0.5rem 0;
  background: white;
  border-radius: 4px;
  border-left: 3px solid #4CAF50;
  line-height: 1.6;
}

.info-rules-list li code {
  background: #f5f5f5;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
  color: #d32f2f;
}

.info-explanation {
  display: block;
  margin-top: 0.5rem;
  font-style: italic;
  color: #666;
  font-size: 0.9rem;
}

.info-notes-list {
  list-style: disc;
  padding-left: 2rem;
  margin: 1rem 0;
  line-height: 1.8;
  color: #555;
}

.info-notes-list li {
  margin: 0.5rem 0;
}

.info-notes-list li strong {
  color: #333;
}

.info-example-box {
  background: #e3f2fd;
  border: 1px solid #2196F3;
  border-radius: 4px;
  padding: 1rem;
  margin: 1rem 0;
  color: #1565C0;
}

.info-example-box strong {
  color: #0d47a1;
}

.info-example-box ul {
  color: #1976D2;
}

.info-example-box li {
  margin: 0.25rem 0;
}

.strategy-cell {
  white-space: nowrap;
}

.strategy-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 500;
  background: #e3f2fd;
  color: #1565C0;
  border: 1px solid #90caf9;
}

.no-strategy {
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/Trades.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;;;EAOE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".trades-container {\n  padding: 0.5rem;\n  width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.trades-header {\n  margin-bottom: 1rem;\n}\n\n.trades-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 2rem;\n}\n\n.trades-header p {\n  margin: 0.5rem 0 0 0;\n  color: #666;\n}\n\n.trades-content {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.trades-controls {\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  display: flex;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.broker-selector,\n.account-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.broker-selector label,\n.account-selector label {\n  font-weight: 500;\n  color: #333;\n}\n\n.broker-selector select,\n.account-selector select {\n  padding: 8px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 1rem;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n\n.broker-selector select:focus,\n.account-selector select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.trade-filter-selector,\n.date-range-selector,\n.symbol-filter-selector,\n.tag-filter-selector,\n.position-filter-selector,\n.option-type-filter-selector,\n.group-by-conid-selector,\n.pnl-period-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.trade-filter-selector label,\n.date-range-selector label,\n.symbol-filter-selector label,\n.tag-filter-selector label,\n.position-filter-selector label,\n.option-type-filter-selector label,\n.group-by-conid-selector label,\n.pnl-period-selector label {\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.group-by-conid-selector input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.column-visibility-selector {\n  position: relative;\n  margin-left: auto;\n  align-self: center;\n}\n\n.column-visibility-selector summary {\n  list-style: none;\n  padding: 8px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #333;\n  background: white;\n  cursor: pointer;\n  user-select: none;\n}\n\n.column-visibility-selector summary::-webkit-details-marker {\n  display: none;\n}\n\n.column-visibility-selector summary::after {\n  content: ' \\25BE';\n}\n\n.column-visibility-selector[open] summary {\n  border-color: #667eea;\n}\n\n.column-visibility-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  z-index: 10;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  padding: 8px 0;\n  min-width: 180px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.column-visibility-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  font-weight: 400;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.column-visibility-option:hover {\n  background: #f8f9fa;\n}\n\n.column-visibility-option input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n}\n\n.trade-filter-selector select,\n.date-range-selector select,\n.symbol-filter-selector input,\n.tag-filter-selector input,\n.position-filter-selector select,\n.option-type-filter-selector select,\n.pnl-period-selector select {\n  padding: 8px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 1rem;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n  min-width: 150px;\n}\n\n.trade-filter-selector select:focus,\n.date-range-selector select:focus,\n.symbol-filter-selector input:focus,\n.tag-filter-selector input:focus,\n.position-filter-selector select:focus,\n.option-type-filter-selector select:focus,\n.pnl-period-selector select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.symbol-filter-selector input {\n  cursor: text;\n}\n\n.trades-table-container {\n  overflow-x: auto;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.trades-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 0;\n  table-layout: auto;\n}\n\n.trades-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.trades-table th {\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.sortable-header {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.sortable-header:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.trades-table tbody tr {\n  border-bottom: 1px solid #eee;\n  transition: background-color 0.2s ease;\n}\n\n.trades-table tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n.trades-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.trades-table td {\n  padding: 10px 8px;\n  font-size: 0.85rem;\n  text-align: left;\n}\n\n.account-cell {\n  font-weight: 500;\n  color: #667eea;\n}\n\n.date-cell {\n  font-weight: 500;\n  color: #333;\n  font-family: 'Courier New', monospace;\n}\n\n.symbol-cell {\n  font-weight: 600;\n  color: #333;\n}\n\n.description-cell {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #555;\n}\n\n.buy-sell-cell {\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #333;\n}\n\n.number-cell {\n  text-align: left;\n  font-family: 'Courier New', monospace;\n  color: #555;\n}\n\n.number-cell.positive {\n  color: #2e7d32;\n  font-weight: 600;\n}\n\n.number-cell.negative {\n  color: #d32f2f;\n  font-weight: 600;\n}\n\n.number-cell.unrealized {\n  color: #ff8c00;\n  font-weight: 600;\n}\n\n.currency-cell {\n  text-align: left;\n  color: #666;\n  font-size: 0.85rem;\n}\n\n.loading, .error, .empty-state {\n  text-align: center;\n  padding: 3rem 2rem;\n  font-size: 1.1rem;\n}\n\n.error {\n  color: #d32f2f;\n  background-color: #ffebee;\n  border-radius: 4px;\n  border: 1px solid #ffcdd2;\n}\n\n.empty-state {\n  color: #666;\n  background: white;\n  border-radius: 8px;\n  padding: 4rem 2rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n@media (max-width: 1400px) {\n  .trades-container {\n    padding: 0.25rem;\n  }\n  \n  .trades-table th,\n  .trades-table td {\n    padding: 8px 6px;\n    font-size: 0.85rem;\n  }\n  \n  .description-cell {\n    max-width: 180px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .trades-container {\n    padding: 0.25rem;\n  }\n  \n  .trades-table th,\n  .trades-table td {\n    padding: 8px 5px;\n    font-size: 0.8rem;\n  }\n  \n  .description-cell {\n    max-width: 150px;\n  }\n}\n\n@media (max-width: 768px) {\n  .trades-container {\n    padding: 0.25rem;\n  }\n  \n  .trades-table-container {\n    font-size: 0.75rem;\n  }\n\n  .trades-table th,\n  .trades-table td {\n    padding: 6px 4px;\n    font-size: 0.75rem;\n  }\n  \n  .description-cell {\n    max-width: 100px;\n  }\n}\n\n/* Grouped trades view styles */\n.group-header-row {\n  background-color: #f5f5f5 !important;\n  font-weight: 600;\n  border-top: 2px solid #ddd;\n  border-bottom: 2px solid #ddd;\n}\n\n.group-header-row:hover {\n  background-color: #e8e8e8 !important;\n}\n\n.group-header-row .symbol-cell {\n  font-size: 1rem;\n  color: #667eea;\n}\n\n.group-detail-header-row {\n  background-color: #f0f0f0 !important;\n  font-weight: 600;\n  font-size: 0.85rem;\n  border-bottom: 1px solid #ddd;\n}\n\n.group-detail-header-cell {\n  padding: 8px 8px !important;\n  color: #555;\n  font-size: 0.85rem;\n}\n\n.group-detail-row {\n  background-color: #fafafa !important;\n}\n\n.group-detail-row:hover {\n  background-color: #f0f0f0 !important;\n}\n\n.group-detail-row td {\n  padding-left: 2rem;\n  font-size: 0.85rem;\n}\n\n/* Totals row styling */\n.totals-row {\n  background-color: #f5f5f5 !important;\n  border-top: 3px solid #667eea;\n  font-weight: 700;\n}\n\n.totals-row:hover {\n  background-color: #f5f5f5 !important;\n}\n\n.totals-cell {\n  padding: 12px 8px !important;\n  font-size: 0.95rem;\n  text-align: left;\n}\n\n.totals-cell.number-cell {\n  text-align: left;\n  font-family: 'Courier New', monospace;\n  font-size: 1rem;\n}\n\n/* Info Section Styles */\n.info-section {\n  width: 100%;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.info-content {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.info-content h3 {\n  color: #333;\n  font-size: 1.8rem;\n  margin: 0 0 2rem 0;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.info-content h4 {\n  color: #444;\n  font-size: 1.4rem;\n  margin: 2rem 0 1rem 0;\n  padding-top: 1rem;\n  border-top: 1px solid #e0e0e0;\n}\n\n.info-content h4:first-of-type {\n  border-top: none;\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.info-content h5 {\n  color: #555;\n  font-size: 1.2rem;\n  margin: 1.5rem 0 0.75rem 0;\n}\n\n.info-intro {\n  color: #666;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0.5rem 0 1rem 0;\n}\n\n.info-section-block {\n  margin-bottom: 2rem;\n}\n\n.info-subsection {\n  margin: 1.5rem 0;\n  padding: 1rem;\n  background: #f9f9f9;\n  border-radius: 6px;\n  border-left: 4px solid #2196F3;\n}\n\n.info-note {\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n  padding: 0.75rem 1rem;\n  margin: 1rem 0;\n  color: #856404;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.info-rules-list {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0;\n}\n\n.info-rules-list li {\n  padding: 0.75rem 1rem;\n  margin: 0.5rem 0;\n  background: white;\n  border-radius: 4px;\n  border-left: 3px solid #4CAF50;\n  line-height: 1.6;\n}\n\n.info-rules-list li code {\n  background: #f5f5f5;\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9em;\n  color: #d32f2f;\n}\n\n.info-explanation {\n  display: block;\n  margin-top: 0.5rem;\n  font-style: italic;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.info-notes-list {\n  list-style: disc;\n  padding-left: 2rem;\n  margin: 1rem 0;\n  line-height: 1.8;\n  color: #555;\n}\n\n.info-notes-list li {\n  margin: 0.5rem 0;\n}\n\n.info-notes-list li strong {\n  color: #333;\n}\n\n.info-example-box {\n  background: #e3f2fd;\n  border: 1px solid #2196F3;\n  border-radius: 4px;\n  padding: 1rem;\n  margin: 1rem 0;\n  color: #1565C0;\n}\n\n.info-example-box strong {\n  color: #0d47a1;\n}\n\n.info-example-box ul {\n  color: #1976D2;\n}\n\n.info-example-box li {\n  margin: 0.25rem 0;\n}\n\n.strategy-cell {\n  white-space: nowrap;\n}\n\n.strategy-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  background: #e3f2fd;\n  color: #1565C0;\n  border: 1px solid #90caf9;\n}\n\n.no-strategy {\n  color: #999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
